import React, { createContext, useContext, useState, useEffect } from 'react';

const SovereignContext = createContext();

export const SovereignProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('pc_theme') || 'dark';
  });
  const [coins, setCoins] = useState(() => {
    return parseInt(localStorage.getItem('pc_coins') || '100', 10);
  });
  const [activeModule, setActiveModule] = useState('landing');

  useEffect(() => {
    try {
      localStorage.setItem('pc_theme', theme);
      const root = typeof document !== 'undefined' ? document.documentElement : null;
      const body = typeof document !== 'undefined' ? document.body : null;

      if (theme === 'light') {
        if (root && root.classList) {
          root.classList.add('light-theme');
          root.classList.remove('dark');
        }
        if (body && body.classList) {
          body.classList.add('light-theme');
          body.classList.remove('dark');
        }
      } else {
        if (root && root.classList) {
          root.classList.remove('light-theme');
          root.classList.add('dark');
        }
        if (body && body.classList) {
          body.classList.remove('light-theme');
          body.classList.add('dark');
        }
      }
    } catch (err) {
      console.warn('Theme update deferred:', err);
    }
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const addCoins = (amount) => {
    setCoins((prev) => {
      const updated = prev + amount;
      localStorage.setItem('pc_coins', updated.toString());
      return updated;
    });
  };

  return (
    <SovereignContext.Provider
      value={{
        theme,
        toggleTheme,
        coins,
        addCoins,
        activeModule,
        setActiveModule
      }}
    >
      {children}
    </SovereignContext.Provider>
  );
};

export const useSovereign = () => {
  const context = useContext(SovereignContext);
  if (!context) {
    throw new Error('useSovereign must be used within a SovereignProvider');
  }
  return context;
};

export default SovereignContext;
